import React from 'react'
import favicon from '../../assets/favicon.ico';

const BaseHead = ({ children }) => {
  return (
    <>
      <link rel="icon" href={`${process.env.GATSBY_BASE_URL}/favicon.svg`} type="image/svg+xml" />
      <link rel="alternate icon" href={favicon} type="image/vnd.microsoft.icon" />
      {children}
    </>
  )
}

export default BaseHead
